<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">

          <h5>
            Update {{ campaignDescription["campaign_name"] }} Data To Master
            Database
          </h5>



        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="finished">Finish</vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">



          <p class="mt-5">
            These are the list of contacts from master database and contacts from
            campaign.
            Upper is the contacts uploaded for campaign and below contacts are the list from master database.
            Please click accept to update uploaded data to master database or ignore to do nothing.
          </p>

        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
      </vs-row>

      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>



      <template v-for="(matched_contact, key) in match_contacts">


        <vs-table stripe :data="matched_contact" class="mt-10">

          <template slot="thead">
          
         
          </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <vs-td>
                <vs-button @click="acceptToUpdate(matched_contact)">Accept</vs-button>
              </vs-td>
            <!-- Master DB -->

              <template v-for="matched,value in matched_contact['master_db_contact']">
              <vs-td>
                <template v-for="field_array_column in  selected_contact_fields">
                  <template v-if="field_array_column.id == value">
                    

                  <h6>{{ field_array_column.name }}</h6>  

                  </template>
                </template>


                <vs-td>


                  <template v-if="Array.isArray(matched)">


                    <template v-for="val1 in matched">
                     {{
                      val1
                      }}

                      
                      <!-- <br> -->

                    </template>

                  </template>
                  <template v-else>
                    {{ matched }}
                  </template>


                </vs-td>
              </vs-td>

            
            </template>
              
            </vs-tr>
            <vs-tr>
              <vs-td>
                <vs-button @click="IgnoreUpdateToMasterDB(matched_contact)">Ignore</vs-button>
              </vs-td>
             
                         <!-- CSV DB -->

                         <template v-for="matched,value in matched_contact['csv_contact']">
                          <vs-td>
                            <template v-for="field_array_column in  selected_contact_fields">
                              <template v-if="field_array_column.id == value">
            
                                <h6>{{ field_array_column.name }}</h6>  
            
                              </template>
                            </template>
            
            
                            <vs-td>


                              <template v-if="Array.isArray(matched)">


                                <template v-for="val1 in matched">
                                 {{
                                  val1
                                  }}
            
                                  
                                  <!-- <br> -->
            
                                </template>
            
                              </template>
                              <template v-else>
                                {{ matched }}
                              </template>


                            </vs-td>
                          </vs-td>
            
                        
                        </template>
             

             
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>
    </vx-card>
    <vs-popup fullscreen style="z-index: 999999;" class="holamundo" title="Update Contact Data To Master Database"
      :active.sync="enrichContactDataToMasterDBPopUp">
      <div class="text-center">


        <template v-for="value,key in  contactDataDescription['master_db_contact']">


          <vs-col>

            
              <template v-for="field_array_column in  selected_contact_fields">


                
                <template v-if="field_array_column.id == key">

                  <div v-if="field_array_column.identifier == 'company_name'">


                   <strong><span>Contact : {{ value }}</span></strong> 
                    
  
         
          </div>

               


                </template>
                </template>
        </vs-col>
  
  
  
          </template>
        <p>
          These are the list of contacts from master database and contacts from
          campaign. Please click on checkbox and submit in order to update in master
          database.
        </p>
      </div>

    
        




      <vs-row vs-w="12" class="mb-10 mt-10">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full"></div>


            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Uploaded Campaign Contacts</u></h6>
            </div>
          </div>
          <template v-for="value,key in  contactDataDescription['csv_contact']">


            <vs-col>
            <div class="vx-row mb-6" v-bind:class="has_different_value.includes(key)? 'bg-grey-gradient pt-5 pb-5 text-dark': ''">
              <div class="vx-col sm:w-1/2 w-full">


                <template v-for="field_array_column in  selected_contact_fields">


                  
                  <template v-if="field_array_column.id == key">

                    <span>{{ field_array_column.name }} :</span>

                  </template>
                </template>


               
              </div>
    
              <div class="vx-col sm:w-1/2 w-full">
                <template v-if="has_different_value.includes(key) && value != 'EMPTY'" v-model="contactDataDescription['csv_contact'][key]">



                  <template v-for="field_array_column in  selected_contact_fields">


                  
                    <template v-if="field_array_column.id == key">

                      <div style="height:85px;" v-if="field_array_column.identifier == 'none_core_field'">

                               <template v-if="Array.isArray(value)">


                    <template v-for="val1,index1 in value">


                      <input :checked="contactDataDescription['master_db_contact'][key].includes(val1)" @click="toggleConfirmedStatus(val1 , $event.target.checked , key)"
                      class="m-3" :name="key" type="checkbox" />

                      {{ val1 }}



                      <!-- <vs-checkbox @click="toggleConfirmedStatus(val1 , $event.target.checked , key)"
                        class="mt-1" :name="key">{{
                          val1
                        }}</vs-checkbox> -->


                      

                    </template>

                  </template>
                  <template v-else>

                    <div style="height:85px;" v-if="field_array_column.identifier == 'none_core_field' && has_different_value.includes(key)">

                      <!-- <vs-checkbox @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                      class="mr-4" :name="key">{{
                        value
                      }}</vs-checkbox> -->


                      <input :checked="contactDataDescription['master_db_contact'][key].includes(value)" @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                      class="m-3" :name="key" type="checkbox" />
                      {{ value }}


                    </div>

                 

         

                  </template>
                     



                </div>
                      <template v-else>


                        <div style="height:150px;" v-if="field_array_column.identifier == 'job_title' || field_array_column.identifier == 'mobile' || field_array_column.identifier == 'email' || field_array_column.identifier == 'ddi' || field_array_column.identifier == 'social_media' || field_array_column.identifier == 'role' || field_array_column.identifier == 'sub_role' ">

                          <template v-if="Array.isArray(value)">
        
                            <template v-for="val,index in value">


                              <!-- {{ contactDataDescription['master_db_contact'][key] }} -->

                              <input :checked="contactDataDescription['master_db_contact'][key].includes(val)" @click="toggleConfirmedStatus(val , $event.target.checked , key)"
                              class="m-3" :name="key" type="checkbox" />
                              {{ val }}
        


                              <!-- <vs-checkbox @click="toggleConfirmedStatus(val , $event.target.checked , key)"
                              class="mr-4" :name="key">{{
                                val
                              }}</vs-checkbox>
                              <br> -->
        
                            </template>
        
        
                            
        
        
                          </template>
        
                   
        
        
        
                        </div>


                      <div v-else>

                        <input :checked="contactDataDescription['master_db_contact'][key].includes(value)" @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                         :name="key" type="checkbox" />
                        {{ value }}

                        <!-- <vs-checkbox  @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                        class="mr-4" :name="key">{{
                          value
                        }}</vs-checkbox> -->

                        
                    


                        
                      </div>

                      </template>



                   

                      <template v-else>

                        <input @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                        :name="key" type="checkbox" />
                        {{ value }}
                        
                        <!-- <vs-checkbox @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                        class="mr-4" :name="key">{{
                          value
                        }}   </vs-checkbox> -->


                        
                    </template>
  
  
                    </template>




                  </template>
                </template>


                <template v-else>
                  


                  <template v-for="field_array_column in  selected_contact_fields">


                  
                    <template v-if="field_array_column.id == key">

                      <div style="height:150px;" v-if="field_array_column.identifier == 'job_title' || field_array_column.identifier == 'mobile' || field_array_column.identifier == 'email' || field_array_column.identifier == 'ddi' || field_array_column.identifier == 'social_media' || field_array_column.identifier == 'role' || field_array_column.identifier == 'sub_role' ">

                  <template v-if="Array.isArray(value)">


                    <template v-for="val1 in value">
                     {{
                      val1
                      }}

                      
                      <!-- <br> -->

                    </template>

                  </template>
                  <template v-else>
                    {{ value }}
                  </template>


                  </div>

                  <template v-else>


                    <div style="height:85px;" v-if="field_array_column.identifier == 'none_core_field' && has_different_value.includes(key)">

                      {{ value }}   



                    </div>
                    
                    <div v-else>

                      <template v-if="Array.isArray(value)">
                        <template v-for="val in value">
                       <span class="ml-1">{{
                        val
                      }} </span> 
  
                        </template>
  
                      </template>
  
                      <template v-else>
                        {{ value }}  
                        </template>


                    </div>
                        
    


                    
                </template>
                  
                    </template>
                   
                  </template>












            


                    


                </template>

               

               


              </div>
            </div>
            <vs-divider class="p-5" />
          </vs-col>
    
    
    
            </template>
        </vs-col>


        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Master DB Contacts</u></h6>
            </div>
          </div>
          <template v-for="value,key in  contactDataDescription['master_db_contact']">


            <vs-col>
              <div class="vx-row mb-6" v-bind:class="has_different_value.includes(key)? 'bg-grey-gradient pt-5 pb-5 text-dark': ''">

                <div class="vx-col sm:w-1/3 w-full">
                  <!-- <span>{{ key }} :</span> -->
                </div>
                <template v-for="field_array_column in  selected_contact_fields">


                  
                  <template v-if="field_array_column.id == key">

                    <div style="height:150px;" v-if="field_array_column.identifier == 'job_title' || field_array_column.identifier == 'mobile' || field_array_column.identifier == 'email' || field_array_column.identifier == 'ddi' || field_array_column.identifier == 'social_media' || field_array_column.identifier == 'role' || field_array_column.identifier == 'sub_role' ">


            
    
              <div class="vx-col sm:w-1/2 w-full">

                    <template v-if="Array.isArray(value)">
                      <template v-for="val in value">
                      {{
                          val
                        }}
                        <!-- <br> -->

                      </template>

                    </template>

                    <template v-else>
                      {{ value }}  
                      </template>


              </div>
            </div>

                    <template v-else>

                      <div style="height:85px;" v-if="field_array_column.identifier == 'none_core_field' && has_different_value.includes(key)">

                        <template v-if="Array.isArray(value)">
                          <template v-for="val in value">
                          {{
                              val
                            }}
                            <!-- <br> -->
    
                          </template>
    
                        </template>
    
                        <template v-else>
                          {{ value }}  
                          </template>

                        </div>

                        <div  v-else>

                          <template v-if="Array.isArray(value)">
                            <template v-for="val in value">
                            {{
                                val
                              }}
                              <!-- <br> -->
      
                            </template>
      
                          </template>
      
                          <template v-else>
                            {{ value }}  
                            </template>


                          </div>


                    </template>


                  </template>
                  </template>
            </div>
            <vs-divider class="p-5" />
          </vs-col>
    
    
    
            </template>
        </vs-col>
    


      </vs-row>

      <div class="text-center">
        <vs-button @click.prevent="submitForm">Submit</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data: () => ({
    has_different_value : [],
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
    review_changes: [],
    match_contacts: [],
    total_pages: 0,
    limit: 10,
    currentx: 1,
    paginate: { limit: 10, offset: 0 },
    contacts: {
      master_phone: [],
      master_switchboard: [],
      site_switchboard: [],
      master_site_switchboard: null,
      company_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      head_office_country: null,
      company_registration_number: null,
      registration_jurisdiction: null,
      status: null,
      parent: null,
      web: [],
      master_web: null,
      master_linkedin: null,
      phone: null,
      linkedin: [],
      country: null,
      revenue: null,
      no_of_employees: null,
    },
    contactDataDescription: {},
    enrichContactDataToMasterDBPopUp: false,
    enrichOtherFieldContactDataToMasterDBPopUp: false,
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription: [],
    enrichContactDataToMasterDB: [],
    selected_contact_fields: [],
    updated_contact_description: [],
  }),
  components: {
    "v-select": vSelect,
    DataGrid,
    flatPickr
  },
  watch: {
    currentx: function (val, oldVal) {
      this.paginate = { limit: 10, offset: (val - 1) * this.limit};
      this.matchedData();
    },
  },
  methods: {
    removeDuplicates(arr) {
    let unique = arr.reduce(function (acc, curr) {
        if (!acc.includes(curr))
            acc.push(curr);
        return acc;
    }, []);
    return unique;
},
    toggleConfirmedStatus(val,toggle,key) {
      console.log(val);
      console.log(toggle);
      console.log(key);




      if (Array.isArray( this.updated_contact_description[key])){

        if (toggle == true) {
         this.updated_contact_description[key].push(val)
      } else {
         this.updated_contact_description[key] =  this.updated_contact_description[key].filter(function(value, index, arr){ return value != val;});
      }

      this.updated_contact_description[key] = this.removeDuplicates(this.updated_contact_description[key])


      }else{
        if (toggle == true){
           this.updated_contact_description[key] = val
        }else{
           this.updated_contact_description[key] = null
        }
      }


      console.log("updated_contact_description" , this.updated_contact_description[key])


    },
 
    acceptToUpdate(data) {
      this.contactDataDescription = data;


      this.contactDataDescription['account_contact_id'] = data['master_db_contact']['account_contact_id']

      console.log("contactDataDescription" , this.contactDataDescription);

      this.updated_contact_description = data['updated_csv']

      this.has_different_value =  this.contactDataDescription['has_different_value']


      for (let key in this.contactDataDescription['csv_contact']) {
        if (this.contactDataDescription['csv_contact'][key] == null || this.contactDataDescription['csv_contact'][key] == '') {
          this.contactDataDescription['csv_contact'][key] = "EMPTY";
        }
      }

      for (let key in this.contactDataDescription['master_db_contact']) {
        if (this.contactDataDescription['master_db_contact'][key] == null || this.contactDataDescription['master_db_contact'][key] == '') {
          this.contactDataDescription['master_db_contact'][key] = "EMPTY";
        }
      }



      this.enrichContactDataToMasterDBPopUp = true;
    },
    submitForm() {

      // this.$vs.notify({
      //           color: "success",
      //           title: "Contact Updated",
      //           text: "The contact was enriched successfully."
      //         });

        this.updated_contact_description['campaignId'] = this.campaignId;
        this.updated_contact_description['accepted'] = this.contactDataDescription['accepted']
        this.updated_contact_description['id'] = this.contactDataDescription['id']
        this.updated_contact_description['account_contact_id'] = this.contactDataDescription['account_contact_id']
        
        let self = this;
        this.$vs.loading();


        this.$store
          .dispatch("contactsManagement/updateMasterDBContact",   this.updated_contact_description)
          .then(res => {
            if (res.data.status == "success") {
              this.$vs.notify({
                color: "success",
                title: "Contact Updated",
                text: "The contact was enriched successfully."
              });
              // this.matchedData()


              // self.enrichContactDataToMasterDBPopUp = false
              location.reload();


              // this.matchedData();
            }
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.$router.replace("/login");
        }
        })
        },
    finished() {
      this.$router
        .push("/contacts/optionsAfterImportContactToCampaign/" + this.campaignId)
        .catch(() => { });
    },
    IgnoreUpdateToMasterDB(data) {
      let self = this;

      let formData = {}
      formData.id = data.id;
      formData.campaignId = this.campaignId;



      this.$store
        .dispatch("contactsManagement/ignoreMasterDBContact", formData)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Contact Ignored",
              text: "This contact has been ignored."
            });
            this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    goBack: function () {
      this.$router.go(-1);
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      if (s.startsWith("ml_")) return "";
      if (s === "master_db_contact") return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    matchedData() {
      this.$vs.loading();
      this.paginate.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/enrich_contact_data_to_masterdatabase",
          this.paginate
        )
        .then(response => {
          this.match_contacts = JSON.parse(response.data).rows;

          this.selected_contact_fields = JSON.parse(response.data).campaign_table_data;

          let total = JSON.parse(response.data).total_pages;
          this.total_pages = Math.ceil(total / this.limit);
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
  },
  mounted() {
    this.getCampaignDescription()
    this.matchedData();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedContactsContacts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}


.width_class {
  width: 580px;
}

.imput_field {
  width: 500px;
}

.accept-button {
  cursor: pointer;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
